import { render, staticRenderFns } from "./WinningWay.vue?vue&type=template&id=bfefecc0&scoped=true&"
import script from "./WinningWay.vue?vue&type=script&lang=js&"
export * from "./WinningWay.vue?vue&type=script&lang=js&"
import style0 from "./WinningWay.vue?vue&type=style&index=0&id=bfefecc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfefecc0",
  null
  
)

export default component.exports